import React, { FC, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Flexbox, FlexboxVertical } from './Layout';
import { Colors } from '../../styles/colors';
import { AccordionSection } from './AccordionSection';
import { Headline4, TextDefault } from './Text';
import { Icon } from './Icon';

const AccordionWrapper = styled.div`
  background-color: ${Colors.white};
  margin-bottom: 1.5rem;
`;
const AccordionHead = styled(Flexbox)`
  padding: 1.25rem 2rem;
  cursor: pointer;
  
  ${Headline4} {
    flex: 1;
    padding-right: 1rem;
    font-weight: 400;
  }
`;
export const AccordionBodyWrapper = styled.div`
  padding: 2rem;
`;

interface Props {
  title: string;
  accentColor?: string;
  collapsed: boolean;
  onClick?: (collapsed: boolean) => void;
}
export const SimpleAccordion: FC<Props> = ({ title, accentColor = Colors.primaryLight,
                                             collapsed, onClick = () => {},
                                             children }) => {
  return (
    <AccordionWrapper>
      <AccordionHead onClick={() => onClick(collapsed)}>
        <Headline4>{ title }</Headline4>
        <Icon icon={collapsed ? 'plus' : 'minus'} size={20} color={accentColor} />
      </AccordionHead>
      <AccordionSection collapsed={collapsed}>
        <AccordionBodyWrapper>
          { children }
        </AccordionBodyWrapper>
      </AccordionSection>
    </AccordionWrapper>
  );
}
